import { render, staticRenderFns } from "./ResetPasswordEmailForm.vue?vue&type=template&id=7d53b960"
import script from "./ResetPasswordEmailForm.vue?vue&type=script&lang=js"
export * from "./ResetPasswordEmailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports